import { useEffect } from 'react';
import { BattleDebugApp } from './battle/BattleDebugApp.js';
import './battle/battleDebug.css';

export default function App() {
  useEffect(() => {
    window.Telegram?.WebApp?.ready();
    window.Telegram?.WebApp?.expand();
  }, []);

  return <BattleDebugApp />;
}
